/* eslint-disable eqeqeq */
import React, { useEffect, useState, useLayoutEffect } from "react";
import { Box, Grid, Typography } from "@material-ui/core";

import * as S from "./styles";

import VitrineRepository from "../../../repositories/vitrineRepository";
import { pt } from "react-date-range/dist/locale";
import { format } from "date-fns";
import cleanStorageBeforeSearch from "../../../utils/cleanStorageBeforeSearch";
import { useHistory } from "react-router";
import { addFeeByDestinoFerias } from "../../../utils/addFeeByDestinoFerias";
import { storage } from "../../../services/firebase";

const ShowCaseLine = ({ user, data }) => {
	const vitrineRepository = new VitrineRepository();
	const [coinAlias, setCoinAlias] = useState("Pontos");

	let history = useHistory();

	const [images, setImages] = useState([]);

	useEffect(() => {
		setCoinAlias(user?.campaign?.campaignConfig?.coinAlias || "Pontos");
	}, [user?.campaign?.campaignConfig?.coinAlias]);

	useLayoutEffect(() => {
		data?.images?.map((d) => getImageByCodes(data.id, d.imageId));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const getValuesByUser = (val, type) => {
		let value = val * user?.catalog?.catalogCurrencyConfig?.conversionRate;

		if (user.campaign) value = addFeeByDestinoFerias(value, type);

		return Math.ceil(Math.round(value));
	};

	const getImageByCodes = async (idVitrine, imageId) => {
		vitrineRepository.getVitrineIcone(idVitrine, imageId).then((res) => {
			setImages((oldState) => [...oldState, { imageId, url: res }]);
		});
	};

	const getWidthVitrines = (length) => {
		switch (length) {
			case 2:
				return 6;
			case 1:
				return 12;
			case 3:
				return 4;
			case 4:
				return 3;
			default:
				return 3;
		}
	};

	const setDatas = (datas) => {
		let weekDayStartDate = format(datas.startDate, "EEEE dd MMMM yyyy", {
			locale: pt,
		});
		let weekDayEndDate = format(datas.endDate, "EEEE dd MMMM yyyy", {
			locale: pt,
		});
		let startDate = new Date(datas.startDate);
		let endDate = new Date(datas.endDate);
		let dataIda = format(datas.startDate, "dd/MM/yyyy");
		let dataVolta = format(datas.endDate, "dd/MM/yyyy");
		let abreviada = `${format(datas.startDate, "dd/MM")} - ${format(datas.endDate, "dd/MM")}`;

		return {
			dataIda,
			dataVolta,
			abreviada,
			weekDayStartDate,
			weekDayEndDate,
			startDate,
			endDate,
		};
	};

	/* Fotos da experiencia, no mesmo formato que o ExperienceCard usa: array de
	   URLs (string). Falha de Storage nao impede abrir o detalhe — devolve vazio
	   e o Carousel mostra o placeholder "Imagem nao fornecida". */
	const loadExperienceImages = (experienceId) => {
		return storage
			.ref()
			.child(`experience/${experienceId}`)
			.listAll()
			.then((res) =>
				Promise.all(res.items.map((itemRef) => itemRef.getDownloadURL()))
			)
			.catch(() => []);
	};

	/* Contexto minimo da busca de Exclusivos.
	   cleanStorageBeforeSearch() apaga o experienceSearch, e a tela de busca
	   monta o SubHeaderSearch a partir dele. O guard de la e
	   `searchState !== undefined`, mas getSessionStorage devolve NULL quando a
	   chave nao existe — null passa pelo guard e o acesso a searchState.cidade
	   derruba a tela. Entao o banner precisa deixar um objeto neutro no lugar.
	   Sem cidade e sem datas o sub-header mostra "Em todas as localizacoes". */
	const emptyExperienceSearch = () =>
		JSON.stringify({ categoria: "", subcategoria: "", subcategorias: [], cidade: "", datas: "" });

	/* US-08 / US-09 — abre o detalhe da experiencia vinculada ao banner.
	   A tela de detalhe le de sessionStorage (nao busca por id sozinha), entao
	   carregamos aqui e so entao navegamos.
	   Fallback da US-09: experiencia inativa, fora de vigencia ou excluida cai
	   na busca geral de Exclusivos em vez de mostrar tela de erro. */
	const goToExperienceDetail = (vitrine) => {
		cleanStorageBeforeSearch();
		sessionStorage.setItem("buscaAtual", "Experiencias");
		sessionStorage.setItem("experienceSearch", emptyExperienceSearch());

		const fallbackToSearch = () => {
			sessionStorage.setItem("experienceSearch", emptyExperienceSearch());
			history.push("/busca/resultado-pesquisa");
		};

		if (!vitrine.experienceId) {
			fallbackToSearch();
			return;
		}

		vitrineRepository
			.getExperienceById(vitrine.experienceId)
			.then((res) => {
				/* 204 = experiencia inexistente, de outra campanha, ou fora de
				   vigencia. Vem sem corpo, entao `experience` fica indefinido e
				   caimos no fallback da US-09. */
				const experience = res?.data?.experience;
				if (!experience) {
					fallbackToSearch();
					return;
				}
				/* O Carousel espera um array de STRINGS (URLs do Storage) — ele faz
				   img.trim() em cada item. As fotos nao vem da API: o fluxo normal
				   (card do resultado de busca) as carrega de experience/{id} no
				   Firebase Storage. Fazemos o mesmo aqui. */
				return loadExperienceImages(experience.id).then((images) => {
					sessionStorage.setItem(
						"@experience-details",
						JSON.stringify({
							experience,
							images,
							serverTime: res?.data?.serverTime || null,
						})
					);
					history.push("/busca/experience-details");
				});
			})
			.catch(() => fallbackToSearch());
	};

	const mountRequestInStorage = (vitrine) => {
		if (vitrine.type) {
			switch (vitrine.type) {
				case "FLIGHT":
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"flySearch",
						JSON.stringify({
							origem: {
								iata: vitrine.airportOrigin,
								airportName: vitrine.airportOriginName,
								description: vitrine.airportOriginName,
							},
							destino: {
								iata: vitrine.airportDestination,
								airportName: vitrine.airportDestinationName,
								description: vitrine.airportDestinationName,
							},
							datas: setDatas({
								startDate: vitrine.startDate,
								endDate: vitrine.endDate,
							}),
							adultos: 1,
							criancas: 0,
							bebes: 0,
							idavolta: true,
							tarifasBagagem: false,
							apenasVoosDiretos: false,
						})
					);
					sessionStorage.setItem("buscaAtual", "Aéreo");
					history.push("/busca/resultado-pesquisa");
					break;
				case "HOTEL":
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"hotelSearch",
						JSON.stringify({
							cidade: {
								code: vitrine.cityCode,
								cityName: vitrine.cityName,
								isoCode: vitrine.country,
							},
							datas: setDatas({
								startDate: vitrine.startDate,
								endDate: vitrine.endDate,
							}),
							qtAdult: 1,
							qtChild: 0,
							qtRooms: 1,
						})
					);
					sessionStorage.setItem("buscaAtual", "Hotel");
					history.push("/busca/resultado-pesquisa");
					break;
				case "CAR":
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"carSearch",
						JSON.stringify({
							cidadeRetirada: {
								countryIso: vitrine.country,
								iata: vitrine.airportOrigin,
								description: vitrine.airportOriginName,
							},
							localRetiradaName: vitrine.locationName,
							localRetirada: {
								rental: {
									name: vitrine.locationName,
								},
								address: {
									address: vitrine.locationName,
								},
								locationCode: vitrine.location,
							},
							horaRetirada: "09:00",
							cidadeDevolucao: "",
							localDevolucao: "",
							horaDevolucao: "09:00",
							datas: setDatas({
								startDate: vitrine.startDate,
								endDate: vitrine.endDate,
							}),
							mesmoLocal: true,
						})
					);
					sessionStorage.setItem("buscaAtual", "Carro");
					history.push("/busca/resultado-pesquisa");
					break;
				case "EXPERIENCE":
					/* Demanda 231 — o banner de Exclusivas passa a ter dois destinos.
					   EXPERIENCE_DETAIL abre direto o detalhe da experiencia vinculada;
					   SEARCH (e as vitrines antigas, que a migracao marcou como SEARCH)
					   vao para o resultado de busca filtrado por categoria/subcategoria/
					   cidade. START_DATE/END_DATE continuam existindo no cadastro, mas
					   agora so controlam a vigencia do banner — nao viram mais filtro
					   de periodo na busca. */
					if (vitrine.redirectType === "EXPERIENCE_DETAIL") {
						goToExperienceDetail(vitrine);
						break;
					}
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"experienceSearch",
						JSON.stringify({
							categoria: vitrine.experienceCategoryId
								? {
										id: vitrine.experienceCategoryId,
										name: vitrine.experienceCategoryName || "",
								  }
								: "",
							/* A busca agora aceita varias subcategorias (lista), entao o
							   banner manda todas as escolhidas no cadastro da vitrine.
							   Mantemos tambem a singular por compatibilidade com telas
							   que ainda leem `subcategoria`. */
							subcategorias: vitrine.subcategories || [],
							subcategoria:
								vitrine.subcategories && vitrine.subcategories.length > 0
									? { id: vitrine.subcategories[0].id }
									: "",
							cidade: vitrine.cityCode
								? { id: vitrine.cityCode, cityName: vitrine.cityName }
								: "",
							datas: "",
						})
					);
					sessionStorage.setItem("buscaAtual", "Experiencias");
					history.push("/busca/resultado-pesquisa");
					break;
				case "BUS":
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"busSearch",
						JSON.stringify({
							origem: {
								iata: vitrine.airportOrigin,
								airportName: vitrine.airportOriginName,
								description: vitrine.airportOriginName,
							},
							destino: {
								iata: vitrine.airportDestination,
								airportName: vitrine.airportDestinationName,
								description: vitrine.airportDestinationName,
							},
							datas: setDatas({
								startDate: vitrine.startDate,
								endDate: vitrine.endDate,
							}),
							adultos: 1,
							idavolta: true,
						})
					);
					sessionStorage.setItem("buscaAtual", "Rodoviário");
					history.push("/busca/resultado-pesquisa");
					break;
				case "PACKAGE":
					cleanStorageBeforeSearch();
					sessionStorage.setItem(
						"packageSearch",
						JSON.stringify({
							destination: {
								cityCode: vitrine.cityCode,
								cityName: vitrine.cityName,
							},
							origin: "",
							dates: "",
							occupancy: [{ adults: 2, children: 0, childrenAges: [] }],
							qtAdult: 2,
							qtChild: 0,
							qtRooms: 1,
						})
					);
					sessionStorage.setItem("buscaAtual", "Pacote");
					history.push("/busca/resultado-pesquisa");
					break;
				default:
					break;
			}
		} else if (vitrine.link && vitrine.link.trim() !== "") {
			window.open(vitrine.link, "_blank");
		} else {
			return;
		}
	};

	return (
		<S.Wrapper>
			<Typography variant="h5">
				<b>{data?.name}</b>
			</Typography>
			<Typography>{data?.description}</Typography>
			<Grid container spacing={2}>
				{data?.images?.map((i, index) => (
					<Grid item xs={12} sm={getWidthVitrines(data?.images.length)} key={i.imageId}>
						<Box sx={{ cursor: "pointer" }} display="flex" flexDirection="column" gridGap={5} onClick={() => mountRequestInStorage(i)}>
							<img alt="imagem" src={images.find((x) => x.imageId == i.imageId)?.url} />
							{i?.name && (
								<Typography variant="h6" style={{ fontSize: "1.06rem" }}>
									<b>{i?.name}</b>
								</Typography>
							)}
							{i?.description && <Typography variant="h6" style={{ fontSize: "1.06rem" }}>{i?.description}</Typography>}
							{i.price && (
								<>
									{i?.originalPrice ? (
										<>
											<Typography variant="body2" component="span">
												de{" "}
												<s>
													{getValuesByUser(i?.originalPrice, i.type)} {coinAlias}
												</s>
											</Typography>
											<Typography variant="h5">
												{" "}
												por {getValuesByUser(i?.price, i.type)} {coinAlias}
											</Typography>{" "}
										</>
									) : (
										<>
											<Typography variant="caption">A partir de</Typography>
											<Typography variant="h5">
												{getValuesByUser(i?.price, i.type)} {coinAlias}
											</Typography>
										</>
									)}
								</>
							)}
						</Box>
					</Grid>
				))}
			</Grid>
		</S.Wrapper>
	);
};

export default ShowCaseLine;
